import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import introduction from '@/components/introduction'
import about from '@/components/about'
import products from '@/components/products'
import news from '@/components/news'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/introduction',
      name: 'introduction',
      component: introduction
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/products',
      name: 'products',
      component: products
    },
    {
      path: '/news',
      name: 'news',
      component: news
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js